import React from 'react';

import DepartmentHeader from "../../../components/v2/DepartmentHeader";
import SubmittedProgramsTable from '../../../components/v2/SubmittedProgramsTable';

export default function AssessmentPrograms(props) {
    return (
        <React.Fragment>
            <div className="text-center fs-2">
                Select programs to work on
            </div>
            
            <div className="p-5 pb-md-4 mx-auto">
                <div className="p-1 text-center">
                    <p className="fs-6 text-muted" style={{"textIndent":"50px"}}>
                        Select programs (degrees, certificates and gen ed areas) to 
                        work on by entering 'Yes' in the boxes next to the desired programs 
                        below. Only programs that already have a finalized setup saved will 
                        appear here.
                    </p>
                </div>

                <DepartmentHeader department={props.department} />

                { props.department
                    ?
                        <SubmittedProgramsTable 
                            mode={props.mode}
                            submittedPrograms={props.department.submittedPrograms}
                            onProgramChanged={props.onProgramChanged}
                            activePrograms={props.activePrograms}
                            />
                    :   <></>
                }
            </div>
        </React.Fragment>
    )
}